import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import { updateNotBillable } from '../../apicalls/invoices';
import { Redirect } from 'react-router-dom';
import { TUnbilledAlert } from './type/Type';
import { useSnackbar } from 'notistack';
import { useRecoilState } from 'recoil';
import { progressFlgState } from '../../GlobalState';
import { DialogProps } from '@material-ui/core/Dialog';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

type TProps = {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  alertList: TUnbilledAlert[];
  setErrorMessage: any;
  setOpenError: any;
  getUnbilledAlerts: any;
};

export const AleartModal: React.FC<TProps> = (props: TProps) => {
  const {
    openModal,
    setOpenModal,
    alertList,
    setErrorMessage,
    setOpenError,
    getUnbilledAlerts
  } = props;

  const classes = useStyles();

  const [selectList, setSelectList] = useState<number[]>([]);
  const { enqueueSnackbar } = useSnackbar();
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm');

  // 選択処理
  const onSelect = (id: number) => {
    if (selectList.includes(id)) {
      // IDが既にリストに存在する場合は削除
      setSelectList(selectList.filter(selectedId => selectedId !== id));
    } else {
      // IDがリストに存在しない場合は追加
      setSelectList([...selectList, id]);
    }
  };

  const onSubmit = () => {
    setProgressFlg(true);
    updateNotBillable(selectList).then(data => {
      if (data === 'Not logged in!') {
        <Redirect to='/' />;
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpenError(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpenError(true);
          } else {
            enqueueSnackbar('更新成功', { variant: 'success' });
            getUnbilledAlerts().finally(() => {
              setProgressFlg(false);
            });
          }
        }
      }
    });
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={maxWidth}
      open={openModal}
      onClose={() => {
        setOpenModal(false);
      }}
      aria-labelledby='max-width-dialog-title'
    >
      <DialogTitle id='confirmation-dialog-title'>
        請求書未発行の工事一覧
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table aria-label='sticky table'>
            <TableBody>
              {alertList.length > 0 &&
                alertList.map((option: TUnbilledAlert) => {
                  return (
                    <TableRow key={option.id}>
                      <StyledTableCell align='center' style={{ width: '10%' }}>
                        <input
                          type='checkbox'
                          className={classes.rowInput}
                          checked={selectList.includes(option.id)} // IDが選択されている場合にチェック
                          onChange={() => onSelect(option.id)} // チェックボックスが選択されたらonSelectを呼び出す
                        />
                      </StyledTableCell>
                      <StyledTableCell
                        align={'left'}
                        style={{ width: '90%', padding: 0 }}
                        className={classes.rowLabel}
                      >
                        <a href={`/constructions/${option.construct_id}/edit`}>
                          {option.construct_name}
                        </a>
                      </StyledTableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          className={classes.cancelButton}
          onClick={() => setOpenModal(false)}
        >
          キャンセル
        </Button>
        <Button
          className={classes.submitButton}
          variant='contained'
          onClick={onSubmit}
          disabled={selectList.length == 0}
        >
          請求不要
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cancelButton: {
      backgroundColor: '#bdbdbd',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#cccccc',
        boxShadow: 3
      }
    },
    submitButton: {
      backgroundColor: '#007dff',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#2691ff',
        boxShadow: 3
      }
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    subpaper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '50%'
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    body: {
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'center',
      padding: '30px 0'
    },
    modalFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    },
    input: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '50%',
      gap: 7
    },
    row: {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: 10
    },
    rowInput: {
      width: 18
    },
    rowLabel: {
      fontSize: 18,
      cursor: 'pointer',
      color: '#0D6EFD',
      textDecoration: 'none'
    }
  })
);
